import { reject, resolve } from 'redux-optimist-promise';
import {
  FETCH_ADDITIONAL_ACCOMMODATIONS,
  CLEAR_ADDITIONAL_ACCOMMODATIONS,
} from 'Store/booking/additional-accommodations/additionalAccommodations.action';
type State = boolean;
const initialState: State = false;
export function isDataFetched(state: State = initialState, action: Action<any>): State {
  switch (action.type) {
    case FETCH_ADDITIONAL_ACCOMMODATIONS:
    case CLEAR_ADDITIONAL_ACCOMMODATIONS:
      return false;

    case reject(FETCH_ADDITIONAL_ACCOMMODATIONS):
    case resolve(FETCH_ADDITIONAL_ACCOMMODATIONS):
      return true;

    default:
      return state;
  }
}
